import Form from './Form.js';
import { FormProvider } from './RechercheExperteProvider.js';

const App = () => (
  <FormProvider>
    <Form />
  </FormProvider>
);

export default App;
